// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0244b1d7","977":"a47b6470"}[chunkId] + ".chunk.js";
};